var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShareIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 14.232c.001-.678-.39-.602 0-1.174.426-.626-1.5-2.076-2.171-2.425l-.309-.16c-.046-.025-.095-.044-.143-.066a.89.89 0 0 1-.34-.26.805.805 0 0 1-.175-.452c-.065-.537.144-.937.496-1.345C11.42 7.138 12 5.62 12 4.055 12.008 1.64 10.245-.09 7.627.004c-1.92.066-3.53 1.27-3.855 3.042-.384 2.041.256 3.842 1.621 5.438.736.86.532 1.61-.557 2.052-.899.347-1.772.748-2.614 1.201a7.434 7.434 0 0 0-1.71 1.32c-.273.286-.45.64-.51 1.019a.253.253 0 0 0 .089.232C2.207 16.053 4.939 17.012 7.766 17c1.827.002 3.602-.567 5.316-1.197 1.504-.554 2.686-1.099.419-.803 2.428-.513-.5-.274-.5-.768Z",
  fill: "#662D91"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 13.5,
  r: 5,
  fill: "#662D91",
  stroke: "#E0DEF0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0DEF0",
  d: "M12 13h7v1h-7z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0DEF0",
  d: "M15 17v-7h1v7z"
})));
export { SvgShareIcon as ReactComponent };
export default __webpack_public_path__ + "64573264ab5f49cfde28a503201e1864.svg";